
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eYr6k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $05f12c2f56a63f58$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $05f12c2f56a63f58$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'ascending',
    'fabric.editor.headingLink.copied': 'Copied!',
    'fabric.editor.headingLink.copyAnchorLink': 'Copy link to heading',
    'fabric.editor.headingLink.copyAriaLabel': 'Copy',
    'fabric.editor.headingLink.descSortingLabel': 'descending',
    'fabric.editor.headingLink.failedToCopy': 'Copy failed',
    'fabric.editor.headingLink.noneSortingLabel': 'none',
    'fabric.editor.inlineComment.marker.end': 'inline comment end',
    'fabric.editor.inlineComment.marker.start': 'inline comment start'
};

});


//# sourceMappingURL=en_GB.742d2977.js.map
